import React from 'react';

/**
 * A flexible loading spinner component.
 * @param {string} size - The size of the spinner ('sm', 'md', 'lg', or 'screen').
 */
export default function LoadingSpinner({ size = 'screen' }) {
    // Define size classes based on the prop
    const sizeClasses = {
        sm: 'h-5 w-5 border-2',         // For use inside buttons
        md: 'h-8 w-8 border-2',         // Medium size
        lg: 'h-16 w-16 border-t-2 border-b-2', // Large size
        screen: 'h-16 w-16 border-t-2 border-b-2', // Original full-screen size
    };

    const spinnerClass = `${sizeClasses[size] || sizeClasses.screen} animate-spin rounded-full border-[#20BEC6]`;

    // If the size is 'screen', render the full-page container
    if (size === 'screen') {
        return (
            <div className="flex justify-center items-center h-screen bg-gray-50">
                <div className={spinnerClass}></div>
            </div>
        );
    }

    // Otherwise, render just the spinner element itself
    return (
        <div className={spinnerClass}></div>
    );
}